import { Block } from '../../components/layout/Block';
import { Props } from './props';
import { CheckPermissionFunction, PermissionGate } from '../../../../Auth/components/PermissionGate';
import React, { ReactElement } from 'react';
import { ExternalIds } from '../../components/parts/ExternalIds';
import { ExternalIdDTO, WorkRelatedIdentifierDTO } from '../../../../api/core';
import { WorkReferencedIdentifierInternal } from '../../components/parts/WorkReferencedIdentifierInternal';
import { WorkReferencingIdentifierInternal } from '../../components/parts/WorkReferencingIdentifierInternal';
import { WorkRelatedIdentifierExternal } from '../../components/parts/WorkRelatedIdentifierExternal';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { IntlShape, useIntl } from 'react-intl';

export const IdsPage = (props: Props): ReactElement => {
  const intl: IntlShape = useIntl();
  return <Block title={`work.header.ids`}>
    <PermissionGate always={false} entity={'work_generic'} field={'external_ids'}>
      {(checkPermission: CheckPermissionFunction): ReactElement =>
        <div className={'col-12'}>
          <ExternalIds
            autoFocus={props.autoFocus}
            extIds={props.modifiedModel.externalIds || []}
            onChange={(externalIds: ExternalIdDTO[]): void => props.setField('externalIds', externalIds)}
            options={getVocabularyOptions(intl.locale, 'external_id_list', props.pubtypeGroup)}
            validation={props.validation?.root?.fields?.external_ids}
            checkPermission={checkPermission}
            title={'work.attr.externalIds'}
            label={'work.attr.externalId'}
            enrichedValues={props.enrichedValues}
          />
        </div>
      }
    </PermissionGate>
    <PermissionGate always={false} entity={'work_generic'} field={'internal_related_identifiers_source'}>
      {(checkPermission: CheckPermissionFunction): ReactElement =>
        <div className={'col-12'}>
          <WorkReferencedIdentifierInternal
            autoFocus={props.autoFocus}
            title={'work.attr.internalRelatedIdentifiersSource'}
            identifiers={props.modifiedModel.internalRelatedIdentifiersSource || []}
            onChange={(identifiers: ExternalIdDTO[]): void => props.setField('internalRelatedIdentifiersSource', identifiers)}
            validation={props.validation?.root?.fields?.internal_related_identifiers_source}
            checkPermission={checkPermission}
            pubtypeGroup={props.pubtypeGroup}
          />
        </div>
      }
    </PermissionGate>
    <PermissionGate always={false} entity={'work_generic'} field={'internal_related_identifiers_target'}>
      {(checkPermission: CheckPermissionFunction): ReactElement =>
        <div className={'col-12'}>
          <WorkReferencingIdentifierInternal
            autoFocus={props.autoFocus}
            title={'work.attr.internalRelatedIdentifiersTarget'}
            identifiers={props.modifiedModel.internalRelatedIdentifiersTarget || []}
            onChange={(identifiers: ExternalIdDTO[]): void => props.setField('internalRelatedIdentifiersTarget', identifiers)}
            validation={props.validation?.root?.fields?.internal_related_identifiers_target}
            checkPermission={checkPermission}
            pubtypeGroup={props.pubtypeGroup}
          />
        </div>
      }
    </PermissionGate>
    <PermissionGate always={false} entity={'work_generic'} field={'external_related_identifiers'}>
      {(checkPermission: CheckPermissionFunction): ReactElement =>
        <div className={'col-12'}>
          <WorkRelatedIdentifierExternal
            autoFocus={props.autoFocus}
            title={'work.attr.externalRelatedIdentifiers'}
            identifiers={props.modifiedModel.externalRelatedIdentifiers || []}
            onChange={(externalRelatedIdentifiers: WorkRelatedIdentifierDTO[]): void => props.setField('externalRelatedIdentifiers', externalRelatedIdentifiers)}
            validation={props.validation?.root?.fields?.external_related_identifiers}
            checkPermission={checkPermission}
            pubtypeGroup={props.pubtypeGroup}
          />
        </div>
      }
    </PermissionGate>
  </Block>;
};
